import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import styles from '../styles/elements/SuccessMessage.module.scss';

const SuccessMessage = (props) => {
    const {title, message, onClose } = props;
    
    return (
        <div className={styles.root}>
            <Container>
                <Row>
                    <Col className="d-flex  flex-column align-items-center">
                            <h1 className="heading1">
                                <FontAwesomeIcon icon={faCheckCircle} height="16" width="16" className="me-2"/>
                                {title}
                            </h1>
                            <p className="heading3 mb-5">{message}</p>
                            <Button size="lg" variant="secondary" onClick={onClose}>
                                Închide
                            </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default SuccessMessage;